import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useQuery } from '@apollo/client/react'
import { useRouter } from 'hooks/useRouter'
// components
import User from 'components/PageComponents/Settings/Users/Edit'
import MainLayoutContainer from 'containers/MainLayout/index'
// themes
import { SettingsIcon } from 'themes/views/settings'
// types
import { IUser } from 'types/graphql'
// graphql
import { USERS_DETAILS_QUERY } from 'graphql/user/queries'
// utils
import get from 'lodash/get'

const UsersEditSettingsPage: React.FC = () => {
  const router = useRouter()

  const { data: usersQuery, loading } = useQuery(USERS_DETAILS_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      filter: { id: router.query.id, companyId: router.query.companyId }
    }
  })

  const user: IUser = get(usersQuery, 'settingsUsers.data[0]')

  return (
    <>
      <Helmet>
        <title>Skefto - User Edit</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={loading}
        label={
          <>
            <SettingsIcon />
            User
          </>
        }>
        <User user={user} />
      </MainLayoutContainer>
    </>
  )
}

export default UsersEditSettingsPage
